// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__M2-IA","title":"Header_title__2iBWJ","side":"Header_side__27Djq"};